<template>

    <modal :show="!!show_create_block_modal" :closable="!loading" @close="$emit('close_create_block_modal')">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{ $t('blocks.title') }}
                    <span v-if="isCreate()">{{ $t('blocks.create') }}</span>
                    <span v-else-if="!isCreate()">{{ $t('blocks.edit') }}</span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close_create_block_modal')">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>


        <div slot="body">

            <div v-if="show_create_block_modal">
                <div class="form-group row" v-if="request.type !== 6/*condolence*/ && request.type !== 5/*inloop*/">
                    <label class="form-control-label col-3">{{ $t('blocks.type') }}</label>
                    <div class="col-9">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="speaker" name="type" class="custom-control-input" :value="3" v-model="request.type" :disabled="!isCreate()">
                            <label class="custom-control-label" for="speaker">{{ $t('blocks.type_speaker') }}</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="media" name="type" class="custom-control-input" :value="4" v-model="request.type" :disabled="!isCreate()">
                            <label class="custom-control-label" for="media">{{ $t('blocks.type_media') }}</label>
                        </div>

                        <div class="custom-control custom-radio custom-control-inline" v-if="companySettings?.call_enabled">
                            <input type="radio" id="call" name="type" class="custom-control-input" :value="7" v-model="request.type" :disabled="!isCreate()">
                            <label class="custom-control-label" for="call" v-tooltip="$t('blocks.type_call_tooltip')">{{ $t('blocks.type_call') }}</label>
                        </div>

                        <form-errors :errors="errors" field="type"/>
                    </div>
                </div>

                <div class="form-group row" v-if="request.type && request.type !== 7">
                    <label class="form-control-label col-3">{{ $t('blocks.with') }}</label>
                    <div class="col-9">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="speaker_photo" name="subblock_type" class="custom-control-input" :value="1" v-model="request.subblock_type">
                            <label class="custom-control-label" for="speaker_photo" v-tooltip="$t('blocks.photo_tooltip')">
                                <span v-if="request.type === 3">{{ $t('blocks.photo') }}</span>
                                <span v-else>
                                    {{ musicOnlyBlockDisabled ? $t('blocks.photo_music') : $t('blocks.photo') }}
                                    <small v-if="request.type === 4"></small>
                                </span>
                            </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="speaker_video" name="subblock_type" class="custom-control-input" :value="2" v-model="request.subblock_type">
                            <label class="custom-control-label" for="speaker_video" v-tooltip="$t('blocks.video_tooltip')">
                                {{ $t('blocks.video') }}
                                <small v-if="request.type === 4"></small>
                            </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline" v-if="!musicOnlyBlockDisabled">
                            <input type="radio" id="no_media" name="subblock_type" class="custom-control-input" :value="4" v-model="request.subblock_type">
                            <label class="custom-control-label" for="no_media" v-tooltip="request.type === 3 ? $t('blocks.no_media_tooltip') : $t('blocks.music_only_tooltip')">
                                {{ request.type === 3 ? $t('blocks.no_media') : $t('blocks.music') }}
                            </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline" v-if="musicOnlyBlockDisabled && request.type === 3">
                            <input type="radio" id="no_media" name="subblock_type" class="custom-control-input" :value="4" v-model="request.subblock_type">
                            <label class="custom-control-label" for="no_media" v-tooltip="$t('blocks.no_media_tooltip')">{{ $t('blocks.no_media') }}</label>
                        </div>

                        <form-errors :errors="errors" field="subblock_type"/>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="form-control-label col-3">{{ $t('blocks.name') }}</label>
                <div class="col-9">
                    <input type="text" class="form-control" v-model="request.name">
                    <form-errors :errors="errors" field="name"/>
                </div>
            </div>

            <div class="form-group row">
                <label class="form-control-label col-3">{{ $t('blocks.comment') }}</label>
                <div class="col-9">
                    <textarea class="form-control" v-model="request.comment"></textarea>
                    <form-errors :errors="errors" field="comment"/>
                </div>
            </div>

            <div class="form-group row" v-if="request.type === 3 || request.type === 7">
                <label class="form-control-label col-3">{{ $t('blocks.duration') }}</label>
                <div class="col-9">
                    <minute-input v-model="request.duration"></minute-input>
                    <small>{{ $t('blocks.duration_hint') }}</small>
                    <form-errors :errors="errors" field="duration"/>
                </div>
            </div>

            <div class="form-group row" v-if="hasBlockChangeWithFiles()">
                <label class="form-control-label col-3"> </label>
                <div class="col-9">
                    <div class="alert alert-warning">
                        {{ $t('blocks.media_warning') }}
                    </div>

                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="delete_confirmation" v-model="request.delete_confirmation">
                        <label class="custom-control-label" for="delete_confirmation">{{ $t('blocks.delete_confirmation') }}</label>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-3"></div>
                <div class="col-9">
                    <small>{{ $t('general.required_fields') }}</small>
                </div>
            </div>

        </div>

        <div slot="footer">
            <button
                type="button"
                class="btn btn-success btn-sm"
                :disabled="hasBlockChangeWithFiles() && !request.delete_confirmation"
                @click="saveCreateOrEditBlock()">
                {{ $t('general.save') }}
            </button>
            <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
                @click="$emit('close_create_block_modal')">
                {{ $t('general.close') }}
            </button>
        </div>

    </modal>

</template>

<script>
    import {mapState} from 'vuex';
    import Modal from '../../components/Modal';
    import TimeInput from '../../components/TimeInput';
    import MinuteInput from '../../components/MinuteInput';
    import FormErrors from '../../components/FormErrors';
    import UtilMixin from '../mixins/UtilMixin';

    export default {
        name: 'BlockEditCreate',

        mixins: [
            UtilMixin
        ],

        components: {
            MinuteInput,
            TimeInput,
            Modal,
            FormErrors
        },

        props: {
            show_create_block_modal: {
                type: Object,
            },
            after_block_id: {
                required: false,
                type: Number,
            }
        },

        data() {
            return {
                loading: false,
                show_modal: false,
                request: {
                    subblock_type: null,
                },

                errors: {}
            };
        },

        computed: {
            musicOnlyBlockDisabled() {
                return this.companySettings?.music_only_block_disabled;
            },

            ...mapState({
                ceremony: state => state.ceremony,
                companySettings: state => state.companySettings
            })
        },

        watch: {
            show_create_block_modal() {
                this.errors = {};

                if (this.show_create_block_modal && this.show_create_block_modal.action !== 'new') {
                    const fixedBlock = (this.show_create_block_modal && this.show_create_block_modal.settings ? this.show_create_block_modal.settings : []).find(setting => setting.name === 'fixed_block' && setting.value);

                    this.request = {
                        ...this.show_create_block_modal,
                        change_type: null,
                        fixed_block: !!fixedBlock
                    };

                    this.request.subblock_type = this.request.subblocks[0] ? this.request.subblocks[0].type : 4 /** no media */;

                    // check if there are files. So assume that there are music files attached to it.
                    if (this.show_create_block_modal.files.length > 0) {
                        this.request.music = true;
                    }
                } else {
                    this.request = {};
                }
            },
            'request.type'() {
                if (this.request.type === 3 || this.request.type === 7) {
                    if (!this.request.duration) {
                        this.request.duration = 300;
                    }
                } else {
                    this.request.duration = null;
                }
            }


        },


        methods: {
            hasNoMedia() {
                if ((this.request.type !== 3 && this.request.type !== 7) || !this.request.id) {
                    return false;
                }

                return this.request.subblocks.filter(subBlock => subBlock.id && subBlock.type !== 4/*geen media*/).length <= 0;
            },

            hasSubBlocks() {
                return (this.request.subblocks.length > 0);
            },

            saveCreateOrEditBlock() {

                if (this.isCreate()) {
                    this.saveNewBlock();
                } else {
                    this.saveBlock(this.request);
                }
            },

            async saveNewBlock() {
                this.errors = {};

                this.loading = true;

                if (this.ceremony.blocks.length) {
                    this.request.order = parseInt([...this.ceremony.blocks].reverse()[0].order) + 1;
                } else {
                    this.request.order = 0;
                }

                try {
                    const response = await this.$http.post(`/api/ceremonies/code/${this.ceremony.code}/blocks`, {
                        ...this.request,
                        add_after_id: this.after_block_id
                    });

                    const new_block = response.data;

                    this.$emit('block_saved', new_block);

                    this.request = {};
                    this.show_modal = null;
                } catch (exception) {
                    if (exception.response && exception.response.status === 422) {
                        this.errors = exception.response.data.errors;
                    } else {
                        if (!exception.response || (exception.response && exception.response.status !== 401)) {
                            alert('Cannot create block');
                        }
                    }
                }


                this.loading = false;

            },


            isCreate() {
                return (this.show_create_block_modal && this.show_create_block_modal.action && this.show_create_block_modal.action === 'new');
            },

            // edit block?
            async saveBlock(block) {
                this.loading = true;

                try {
                    const response = await this.$http.put(`/api/ceremonies/code/${this.ceremony.code}/blocks/${block.id}`, block);

                    this.$emit('block_saved', response.data);
                } catch (exception) {

                    if (exception.response && exception.response.status === 422) {
                        this.errors = exception.response.data.errors;
                    } else {
                        if (!exception.response || (exception.response && exception.response.status !== 401)) {
                            alert('Cannot save block');
                        }
                    }
                }


                this.loading = false;
            },

            hasBlockChangeWithFiles() {
                if (this.show_create_block_modal &&
                    this.show_create_block_modal.subblocks &&
                    this.show_create_block_modal.subblocks[0] &&
                    this.show_create_block_modal.subblocks[0].files &&
                    this.show_create_block_modal.subblocks[0].files.length > 0 &&
                    this.request.subblock_type &&
                    this.show_create_block_modal.subblocks[0].type !== this.request.subblock_type

                ) {
                    return true;
                }
            }

        }
    };
</script>

<style scoped>

</style>
